import React, { Fragment } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { Button, Form } from "react-bootstrap";


function Professionalskills(props) {
  const { professionallinks, setProfessionallinks, setFormDetail, formDetail, languageData, handleResetData } = props;

  const addNewProfessionallinks = () => {
    let newOdj = {
      skill: "",
      percentage: "",
    };
    let portForm = { ...professionallinks }
    let protItem = [...professionallinks.skills, newOdj]
    portForm['skills'] = protItem
    setProfessionallinks({ ...portForm });
  };
  const removeProfessionallinks = (index) => {
    let newArr = { ...professionallinks };
    let protItem = newArr.skills;
    if (protItem.length > 1) {
      protItem.splice(index, 1);
    }
    newArr['skills'] = protItem
    setProfessionallinks(newArr);
  };

  const handleInputValue = (index, name, value) => {
    let newArr = { ...professionallinks };
    let arr = [...newArr.skills]
    arr[index][name] = value
    setProfessionallinks({ ...professionallinks, skills: arr })
  }
  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent the Accordion from toggling
    setFormDetail({
      ...formDetail,
      skillSection: { ...formDetail.skillSection, status: !formDetail?.skillSection?.status }
    });
    setProfessionallinks({
      ...professionallinks,
      status: !professionallinks?.status
    });
  };

  // const handleResetData = (e) => {
  //   console.log('defaultFormDetail.skillSection: ', defaultFormDetail.skillSection);
  //   const portData = defaultFormDetail.skillSection
  //   console.log('portData: ', portData);
  //   setProfessionallinks(portData);
  // };

  return (
    <Fragment>
      <Accordion.Header>
        <div className="drop_header_dflex">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/icon/skills.png" width={'9%'} alt="Add Professional Skills" /> {" "}
            <span style={{ marginLeft: '15px' }}>{languageData?.addProfessionalSkills}</span>
          </div>
          {/* <Form.Check
            defaultChecked={professionallinks?.status}
            style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
            type="switch"
            className="custom-switch"
            onChange={handleToggle}
            onClick={(e) => e.stopPropagation()} // Prevent event bubbling
          /> */}
          <div style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}>
            <label
              className="custom-toggle-ios m-1"
              style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
              onClick={(e) => e.stopPropagation()} // Prevent event bubbling
            >
              <input
                type="checkbox"
                checked={professionallinks?.status}
                onChange={handleToggle}
              />
              <span className="slider-ios">
                {professionallinks?.status ? 'Show' : 'Hide'}
              </span>
            </label>
          </div>
        </div>
      </Accordion.Header>
      {professionallinks &&
        <Accordion.Body>
          {professionallinks && professionallinks.skills.length > 0 && professionallinks.skills.map((item, index) => (
            <div key={index}>
              <div className="row new_fild_shadow" style={{ background: '#f8f8ee', borderRadius: 10 }}>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.skill}:</label>
                    <input
                      placeholder="HTML/CSS..."
                      className="form-control"
                      value={item.skill}
                      onChange={(e) => handleInputValue(index, 'skill', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.percentage}:</label>
                    <div className="d-flex">
                      <input
                        placeholder="%..."
                        className="form-control"
                        value={item.percentage}
                        onChange={(e) => handleInputValue(index, 'percentage', e.target.value)}
                      />
                      {index > 0 && (
                        <div className="sav-proj-btn">
                          <Button
                            style={{ borderRadius: 50, fontSize: 10, background: '#ff966a', border: 0, color: '#000', fontWeight: 400, marginLeft: 10 }}
                            onClick={() =>
                              removeProfessionallinks(index)
                            }
                          >
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {index === professionallinks.skills.length - 1 && (
                <div className="sav-proj-btn">
                  <Button
                    onClick={addNewProfessionallinks}
                    style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                    size='md'
                  >
                    {languageData?.addMore}
                  </Button>
                  <Button
                    style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500, marginLeft: 20 }}
                    size='md'
                    onClick={() => handleResetData('skillSection')}
                  >
                    {languageData?.reset}
                  </Button>
                </div>
              )}
            </div>
          ))}
        </Accordion.Body>
      }
    </Fragment>
  );
}
export default Professionalskills;
